import React, { useState, useEffect } from "react";
import "./style.css";
import { Input, Button, Popover } from "antd";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import uploadIcon from "../../../assets/images/upload.png";
import useApp from "../../../hooks/useApp";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Layout from "../../../layout";
import { IoIosArrowForward } from "react-icons/io";

const { TextArea } = Input;

const BugReport = () => {
  const navigate = useNavigate();
  const { sendBugReport, loading } = useApp();
  const [inp, setInp] = useState(null);
  const [description, setDescription] = useState("");
  const [fileList, setFileList] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [isImageList, setIsImageList] = useState(false);

  const hints = useSelector((state) => state.TechAppReducer.hints);

  const upload = (e) => {
    let list = [];
    if (
      e.target.files.length > 5 ||
      fileList.length + e.target.files.length > 5
    ) {
      toast.warning("حداکثر ۵ عکس میتوانید بارگذاری کنید");
    } else {
      for (var i = 0; i < e.target.files.length; i++) {
        list.push(e.target.files[i]);
        fileList.push(e.target.files[i]);
      }
      list.forEach((li) => {
        imageList.push(URL.createObjectURL(li));
      });
      setIsImageList(true);
    }
  };

  const removeFileHandler = (url, index) => {
    setImageList(imageList.filter((img) => img !== url));
    setFileList(
      fileList.filter((file, i) => {
        return i !== index;
      })
    );
  };

  useEffect(() => {
    setIsImageList(false);
  }, [isImageList]);

  return (
    <Layout>
      <div className="techapp-bug-report">
        {/* header */}
        <div className="tech-app-header">
          <IoIosArrowForward
            style={{ fontSize: "24px", paddingBottom: "5px" }}
            onClick={() => {
              navigate("/techapp/profile");
            }}
          />
          <span
            onClick={() => {
              navigate("/techapp/profile");
            }}
            style={{ marginRight: "10px", cursor: "pointer" }}
          >
            گزارش مشکل در نرم افزار
          </span>
          {hints.map((hint, index) => {
            if (
              hint.section === "bug_report" &&
              hint.type === "text" &&
              hint.body.length > 0
            ) {
              return (
                <Popover
                  key={index}
                  trigger={"click"}
                  placement="bottom"
                  title={<div style={{ textAlign: "right" }}>راهنما</div>}
                  content={
                    <div style={{ textAlign: "right", maxWidth: 270 }}>
                      {hint.body}
                    </div>
                  }
                >
                  <div style={{ marginRight: "auto" }} className="help_button">
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                </Popover>
              );
            } else if (
              hint.section === "bug_report" &&
              hint.type === "link" &&
              hint.body.length > 0
            ) {
              return (
                <div
                  style={{ marginRight: "auto" }}
                  onClick={() => window.open(hint.body, "_blank")}
                  className="help_button"
                >
                  <IoIosHelpCircleOutline
                    style={{ color: "#1e5279", fontSize: 22 }}
                  />
                </div>
              );
            }

            return '';
          })}
        </div>
        {/* description */}
        <div className="techapp-bugreport-desc">
          <TextArea
            placeholder={"توضیحات خود را در این قسمت وارد کنید"}
            style={{
              paddingTop: "5px",
              maxHeight: "120px",
              borderRadius: "5px",
            }}
            id="bug_report_description_input"
            autoSize
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        {/* uploaded files */}
        <div className="techapp-bugreport-files">
          {imageList.length > 0 &&
            imageList.map((url, index) => (
              <div style={{ position: "relative" }}>
                <img
                  src={url}
                  id="image-uploaded"
                  key={index}
                  className="techapp-define-cost-upload-image"
                  alt={'image'+index}
                />
                <span
                  onClick={() => removeFileHandler(url, index)}
                  className="techapp-upload-remove-btn"
                >
                  x
                </span>
              </div>
            ))}
        </div>
        {/* actions area */}
        <div className="techapp-bugreport-actions">
          <Button
            onClick={() => {
              sendBugReport(description, fileList);
            }}
            loading={loading}
            id="bug_report_form_submit_button"
          >
            ارسال اطلاعات
          </Button>
          <input
            onChange={upload}
            type="file"
            name="filefield"
            multiple="multiple"
            style={{ display: "none" }}
            ref={(fileInput) => setInp(fileInput)}
          />
          <Button onClick={() => inp.click()}>
            <img src={uploadIcon} alt="upload" />
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default BugReport;
